module.exports = __webpack_public_path__ + "static/media/bytt-no-20.81411f58.mp3";